import { useLocation } from 'react-router-dom';
import TextField from '../../../../core/common/textFields/TextField';
import DateComp from '../../../../core/common/dateComponent/DateComp';
import dayjs from 'dayjs';
import Select, { StylesConfig } from "react-select";
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';

const DescriptionTab = ({ formik, projectLookups }: any) => {
    const location = useLocation();
    const isReadOnly = location.pathname.includes('/projects/view-project');

    return (
        <div className="row">
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Description:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="Description"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.description")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Analysis"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.analysis")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Lead Status"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.status")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Lead Status Description"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.statusDetails")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                <TextField
                                    label="Job Name"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.jobName")}
                                    disabled={isReadOnly}
                                />
                            </div> */}
                            <div className="col-md-12">
                                <p className='mb-0 input-label'>Job Type</p>  <Select
                                    styles={customStyles}
                                    className="select"
                                    placeholder='Select'
                                    options={
                                        projectLookups?.result?.Lst_JobType
                                            .map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            })) || []
                                    }
                                    value={formik.values.opportunityDetailsDescription.jobType.value ?
                                        {
                                            label: formik.values.opportunityDetailsDescription.jobType.value || 'Select',
                                            value: formik.values.opportunityDetailsDescription.jobType.id
                                        }
                                        :
                                        null
                                    }
                                    onChange={(selectedOption: any) => {
                                        formik.setFieldValue('opportunityDetailsDescription.jobType.value', selectedOption.label)
                                        formik.setFieldValue('opportunityDetailsDescription.jobType.id', selectedOption.value)
                                    }
                                    }
                                />
                            </div>
                            <div className="col-md-12 mt-2">
                                <div className=''>
                                    <div className='input-label '>
                                        Est. Sales Amount
                                    </div>
                                    <div className='br-gray text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.opportunityDetailsDescription.saleAmount} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Lead Source"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.leadSource")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Source Description"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.sourceDescription")}
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Ad Code"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.adCode")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Property Address:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 1"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.addressLine1")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 2"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.addressLine2")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="City"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.city")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="State/Region"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.state")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="ZipCode"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.zipCode")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Appointment Details:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="1st Contact Dt"
                                    type="text"
                                    value={
                                        formik?.values?.opportunityDetailsAppointment?.firstContactDate
                                            ? dayjs(formik.values.opportunityDetailsAppointment.firstContactDate).format('MMM-DD-YYYY')
                                            : ""
                                    }
                                    // {...formik.getFieldProps("opportunityDetailsAppointment.firstContactDate")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="1st Appt. Date"
                                    type="text"
                                    value={
                                        formik?.values?.opportunityDetailsAppointment?.firstAptDate
                                            ? dayjs(formik.values.opportunityDetailsAppointment.firstAptDate).format('MMM-DD-YYYY')
                                            : ""
                                    }
                                    // {...formik.getFieldProps("opportunityDetailsAppointment.firstAptDate")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Appt. Maker"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsAppointment.appointmentMaker.value")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 d-flex justify-content-end '>
                <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px", zIndex: 1 }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
            </div>
        </div>

    )
}

export default DescriptionTab